import BaseModel from '../../BaseModel';

export default class NotificationTemplate extends BaseModel {
  static entity = 'notificationTemplates';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      companyId: this.attr(null),
      name: this.string(''),
      type: this.string(''),
      channel: this.string(''),
      template: this.string(''),
    };
  }

  static apiConfig = {
    actions: {
      async fetch(companyId) {
        return this.get(`companies/${companyId}/notification-templates`);
      },
      update(id, payload) {
        return this.put(`companies/notification-templates/${id}`, payload);
      },
    },
  }
}
